import React, { useContext } from "react";
import "./mainContent.css";
import Cbm from "./subCom/cbm/cbm.js";
import Ems from "./subCom/ems/ems.js";
import MindaDashboard from "./subCom/minda/dashboard/MindaDashboard.js";
import OperatorScreen from "./subCom/minda/operatorScreen/operatorScreen.js";
import Quality from "./subCom/minda/Quality/Quality.js";
import ValueAdj from "./subCom/valueAdj/valueAdj.js";
import StampingAndOn from "./subCom/andOn/stamping/andOn.js";
import CncAndOn from "./subCom/andOn/cnc/andOn.js";
import { Routes, Route } from "react-router-dom";
import { AuthInfo } from "../../App";
import { DownTimeTable } from "./subCom/downtime/downtime";
import { devMode, Logout } from "../../utils";
import { LeaderBoard } from "./subCom/LeaderBoard/LeaderBoard";
import { GMA } from "./subCom/gma/gma";
import { ToastContainer } from "react-toastify";
import { useLocation } from 'react-router-dom';
import { WeldLine } from "./subCom/andOn/weldLine/weldLine";
import {ProductionPlanning} from "./subCom/productionPlanning/ProductionPlanning";
// import MachineAnalysis from "./subCom/genericMachineAnalysis/MachineAnalysis";
//import ResourceAllocation from './subCom/resourceAllocation/ResourceAllocation'
import WeldAnalysis from "./subCom/weldAnalysis/WeldAnalysis";





function MainContent(props) {
  const { userId, userInfo } = useContext(AuthInfo);    

  if(!userId && !devMode){
    const {pathname} = useLocation();
    Logout(pathname.slice(1,pathname.length));
  }


  return (
    <>
    <ToastContainer/>
    <section id="mainContent" className={props.noSideNav?"mainContent fullWidth":"mainContent"}>
        <Routes>
        <Route path="andon">
            <Route
              path="cnc"
              element={
                <>
                <CncAndOn />
                </>
              }
            />
            <Route
              path="stamping"
              element={
                <>
                  <StampingAndOn />
                </>
              }
            />
            <Route
              path="weldLine"
              element={
                <>
                  <WeldLine />
                </>
              }
            />
        </Route>
        <Route
          path="cbmpage"
          element={
            <>
              <Cbm />              
            </>
          }
        />
        <Route
          path="emspage"
          element={
            <>
              <Ems />
            </>
          }
        />
        <Route
          path="devtestbase"
          element={
            <>
              <h1>Test Bed</h1>
              <ValueAdj />
            </>
          }
        />
        <Route
          path="operatorScreen/:planId"
          element={
            <>
              <OperatorScreen
                userId={props.userId}
                iden={"operator"}
                showLS={props.showLS}
                setShowLS={props.setShowLS}
              />
            </>
          }
        />
        <Route
          path="quality"
          element={
            <>
              <h2>Quality</h2>
              <Quality
                userId={props.userId}
                iden={"operator"}
                showLS={props.showLS}
                setShowLS={props.setShowLS}
              />
            </>
          }
        />
        <Route
          path="mindaDashboard"
          element={
            <>
              <MindaDashboard />
            </>
          }
        />
        <Route
          path="downtime"
          element={
            <>
              <h2>Downtime</h2>
              <DownTimeTable />
            </>
          }
        />
        <Route
          path="leaderBoard"
          element={
            <>
              <h2>LeaderBoard</h2>
              <LeaderBoard />
            </>
          }
        />
        <Route
          path="gma"
          element={
            <>
              <h2>GMA</h2>
              <GMA />
            </>
          }
        />
        <Route path="" element={<h1></h1>} />
        <Route
          path="plan"
          element={
            <>
              <h2>Production planning</h2>
               <ProductionPlanning/> 
            </>
          }
        />
        <Route
          path="machine"
          element={
            <>
              <h2>Machine Analysis</h2>
              {/* <MachineAnalysis/> */}
            </>
          }
        />
        {/* <Route
          path="resourceplanning"
          element={
            <>
              <h2>Resource Allocation</h2>
              <ResourceAllocation/>
            </>
          }
        /> */}
         <Route
          path="weldAnalysis"
          element={
            <>
              <h2>Weld Analysis</h2>
              <WeldAnalysis/>
            </>
          }
        />
      </Routes>
      <AuthInfo.Consumer>{(value) => {}}</AuthInfo.Consumer>
    </section>
    </>
  );
}

export default MainContent;
